<div mat-dialog-title class="flex justify-between items-center">
  <h2 class="grow">{{ helpTopic.name }}</h2>
  <span class="flex-auto"></span>
  <button mat-icon-button [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="sidenav__list">
    <div class="sidenav__list-row">
      <div class="sidenav__list-col--key sidenav-key-column">Quick Text</div>
      <div class="sidenav__list-col sidenav-value-column">{{ helpTopic.description }}</div>
    </div>

    <mat-divider></mat-divider>
    <div class="sidenav__list-row">
      <div class="sidenav__list-col--key sidenav-key-column">Description</div>
      <div class="sidenav__list-col sidenav-value-column">
        <p class="whitespace-pre-wrap max-w-full break-words" [innerHTML]="helpTopic.narrative | safeHTML"></p>
      </div>
    </div>

    <mat-divider></mat-divider>
    <div class="sidenav__list-row">
      <div class="sidenav__list-col--key sidenav-key-column">Topic Section</div>
      <div class="sidenav__list-col sidenav-value-column">{{ helpTopic.helpTopicSectionCode }}</div>
    </div>
  </div>

  <div class="sidenav__list-row">
    <div class="sidenav__list-col--key sidenav-key-column"></div>
    <div class="sidenav__list-col sidenav-value-column flex justify-end">
      <a mat-flat-button target="_blank" color="primary" routerLink="/help-topics-user">
        Search More
      </a>
    </div>
  </div>
</mat-dialog-content>